import { HR_ROLES, OFFICE_ROLES, type Role } from '@hr/shared';

/** HR (admin, recruiter): редагує конкурси, кандидатів, реєстр, персонал. */
export function isHr(role: Role): boolean {
  return (HR_ROLES as readonly Role[]).includes(role);
}

/** Офісні ролі бачать реєстр і рекрутинг; `employee` — тільки свій кабінет. */
export function isOffice(role: Role): boolean {
  return (OFFICE_ROLES as readonly Role[]).includes(role);
}
